import React, {Component} from 'react';
import PropTypes from "prop-types";
import {translate} from 'react-i18next';
import {Link} from 'react-router-dom';
import ErrorForm from '../../App/ErrorForm';


class ForgotView extends Component {

  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);

    this.state = {
      email: ''
    };
  }

  handleChange(event) {
    const target = event.target;
    const value = target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });
    this.props.clearError();
  }

  handleSubmit(event) {
    event.preventDefault();
    this.props.action({
      email: this.state.email
    });
  }

  render() {
    const {email} = this.state;
    const {t, inProgress, errors} = this.props;
    return (
      <form onSubmit={this.handleSubmit}>
        <div className="form__title">{t('recovery_password')}</div>
        <div className="form__helper">
            <Link to="#" onClick={this.props.onCancel}>
              {t('back_in_login')}
            </Link>
        </div>
        <div className="form__row">
          <input
            name='email'
            autoComplete='off'
            type="text"
            placeholder={t('email_address')}
            className="input input--block"
            value={email}
            onChange={this.handleChange}
          />
        </div>
        <ErrorForm
          errors={errors}
        />
        <div className="form__row">
          <div className='login__one-buttons'>
            <input
              className="form__button"
              type="submit"
              value={t('recovery')}
              disabled={!email || inProgress}
              autoComplete='off'
            />
          </div>
        </div>
      </form>
    );
  }
}

ForgotView.propTypes = {
  inProgress: PropTypes.bool,
  errors: PropTypes.array,
  action: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

export default translate('translations')(ForgotView);



// WEBPACK FOOTER //
// ./src/components/Customer/Auth/ForgotView.js